export const NavigationItems: {url: string, label: string }[] = [
    {url: 'users', label: 'Users' },
    {url: 'applications', label: 'Applications' }
];

export const SubNavigationItems: {url: string, label: string }[] = [
    {url: 'settings', label: 'Settings' },
    {url: 'profile', label: 'Profile' }
];
